import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ReactionsHttpClient } from './reactions-http-client';
import { ReactionActions } from './reactions.store';

@Injectable({ providedIn: 'root' })
export class ReactionEffects {
  public effect = createEffectFactory(ReactionActions, this.actions$);

  public addNoteReaction$ = this.effect(ReactionActions.addNoteReaction, ({ payload }) =>
    this.reactionsHttpClient.addNoteReaction(payload.data).pipe(
      map(response =>
        ReactionActions.addNoteReactionSuccess({
          payload: { data: response, correlationId: payload.correlationId },
        }),
      ),
      catchError(error =>
        of(
          ReactionActions.addNoteReactionFailed({
            payload: { error, data: payload.data, correlationId: payload.correlationId },
          }),
        ),
      ),
    ),
  );

  public removeNoteReaction$ = this.effect(ReactionActions.removeNoteReaction, ({ payload }) =>
    this.reactionsHttpClient.removeNoteReaction(payload.data).pipe(
      map(response =>
        ReactionActions.removeNoteReactionSuccess({
          payload: { data: response, correlationId: payload.correlationId },
        }),
      ),
      catchError(error =>
        of(
          ReactionActions.removeNoteReactionFailed({
            payload: { error, data: payload.data, correlationId: payload.correlationId },
          }),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private reactionsHttpClient: ReactionsHttpClient,
  ) {}
}
